import { createStore } from "@reduxjs/toolkit";
import allReducers from "store/allReducers";

// Permite múltiples reducers

export const store = createStore(allReducers);

export default store;
